import PropTypes from 'prop-types';
import {Component} from 'react';
import {Button, Header, Image} from 'semantic-ui-react';
import {Testimonial} from 'ducks/testimonials';
import removeImageBtn from '../images/cancel-btn.svg';
import deleteIcon from '../images/delete-icon.svg';
import EditableTitle from './EditableTitle';
import MonthYear from './MonthYear';
import Note from './Note';
import './TestimonialEdit.scss';
import TestimonialsImageUploadContainer from './TestimonialImageUploadContainer';

export default class TestimonialEdit extends Component {
  static propTypes = {
    testimonial: PropTypes.object,
    save: PropTypes.func.isRequired,
    remove: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = props.testimonial || new Testimonial();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.testimonial !== this.props.testimonial) {
      this.setState({...this.props.testimonial});
    }
  }

  clear = () => {
    this.setState({
      title: undefined,
      image: undefined,
      description: undefined,
      author: undefined,
      month: undefined,
      year: undefined
    });
    this._note.onChange({}, {value: ''});
  };

  saveTestimonial = () => {
    const {save} = this.props;
    save(this.state);
    this.clear();
  };

  removeImage = () => {
    this.setState({image: undefined});
  };

  onFileUpload = (fileUrl) => {
    this.setState({image: fileUrl});
  };

  render() {
    const {remove} = this.props;
    const {title, image, description, author, month, year, id} = this.state;
    const isButtonEnabled = title || image || description || author || month || year;

    return (
      <div className="testimonial-edit">
        {id &&
        <div className="top-button-bar">
          <Image className="delete" src={deleteIcon} onClick={() => remove(this.state)}/>
        </div>
        }
        <div className="title-container">
          <Header as="h5" className="tlabel">Testimonial title</Header>
          <EditableTitle className="testimonial-title"
                         placeholder="Enter testimonial title"
                         title={title}
                         onUpdateData={(data) => this.setState(data)}
                         isEnabled={true}
                         editMaxLength={32}/>
        </div>

        <div className="row2">
          {image ?
            <div className="image-container">
              <Image src={image}/>
              <Image className="delete-image" src={removeImageBtn} onClick={this.removeImage}/>
            </div> :
            <TestimonialsImageUploadContainer className="dropzone" testimonial={this.state}
                                              onFileUpload={this.onFileUpload}/>}
          <Note className="testimonial-description"
                ref={(ref) => this._note = ref}
                placeholder={'Enter testimonial description'}
                maxChars={image ? 200 : 250}
                label={'Testimonial description'}
                enabled
                value={description}
                onChange={(field, value) => this.setState({description: value})}
          />
        </div>
        <div className="row3">
          <div className="author-container">
            <Header as="h5" className="tlabel">Testimonial author</Header>
            <EditableTitle className="testimonial-author"
                           placeholder="Enter client name"
                           title={author}
                           onUpdateData={(data) => this.setState({author: data.title})}
                           isEnabled={true} editMaxLength={50}/>
          </div>
          <div className="month-year-container">
            <Header as="h5" className="tlabel">Testimonial date</Header>
            <MonthYear
              month={month}
              year={year}
              onChange={(data) => this.setState(data)}/>
          </div>
        </div>
        <div className="button-bar" style={{justifyContent: id ? 'flex-end' : 'space-between'}}>
          {!id && <Button secondary disabled={!isButtonEnabled} onClick={this.clear}>Clear</Button>}
          <Button primary disabled={!isButtonEnabled} onClick={this.saveTestimonial}>Save</Button>
        </div>
      </div>
    );
  }
}
